import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SOCIETY_PORTAL, SOCIETY_PORTAL_LOGIN } from '../../../../Routing/routes';
import { ErrorMessage, Form, Formik } from 'formik';
import { forgotPasswordValidation } from '../../../../validationSchema/SocietyController/authSchema';

const ForgotPassword = () => {
    const [showModal, setShowModal] = useState(false);

    const handleSubmit = (values, { resetForm }) => {
        // Handle forgot password logic here
        setShowModal(true);
        resetForm();
    }

    return (
        <>
            <section className="auth forgot-password-page bg-base d-flex flex-wrap">
                <div className="auth-left d-lg-block d-none">
                    <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                        <img src="/assets/images/auth/forgot-pass-img.png" alt="" />
                    </div>
                </div>
                <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                    <div className="max-w-464-px mx-auto w-100">
                        <div>
                            <h4 className="mb-12">Forgot Password</h4>
                            <p className="mb-32 text-secondary-light text-lg">
                                Enter the email address associated with your account and we will
                                send you a link to reset your password.
                            </p>
                        </div>
                        <Formik
                            initialValues={{
                                email: ''
                            }}
                            validationSchema={forgotPasswordValidation}
                            onSubmit={handleSubmit}
                        >
                            {(formik) => (
                                <Form>
                                    <div className="mb-16">
                                        <div className="icon-field">
                                            <span className="icon top-50 translate-middle-y">
                                                <Icon icon="mage:email" />
                                            </span>
                                            <input
                                                type="email"
                                                className="form-control h-56-px bg-neutral-50 radius-12"
                                                placeholder="Enter Email"
                                                name="email"
                                                onChange={(e) => formik.setFieldValue('email', e.target.value)}
                                                value={formik.values.email}
                                            />
                                        </div>
                                        <div className={`text-danger text-sm italic h-4 text-wrap break-words mb-4`}>
                                            <ErrorMessage name={`email`} />
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                    >
                                        Continue
                                    </button>
                                    <div className="text-center mt-24">
                                        <Link to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN} className="text-primary-600 fw-bold">
                                            Back to Sign In
                                        </Link>
                                    </div>
                                    <div className="mt-120 text-center text-sm">
                                        <p className="mb-0">
                                            Already have an account?{" "}
                                            <Link to={SOCIETY_PORTAL + SOCIETY_PORTAL_LOGIN} className="text-primary-600 fw-semibold">
                                                Sign In
                                            </Link>
                                        </p>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </section>

            {/* Modal */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-body p-40 text-center">
                                <div className="mb-32">
                                    <img src="/assets/images/auth/envelop-icon.png" alt="" />
                                </div>
                                <h6 className="mb-12">Verify your Email</h6>
                                <p className="text-secondary-light text-sm mb-0">
                                    Thank you, check your email for instructions to reset your password
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <div className="mt-32 text-sm">
                                    <p className="mb-0">
                                        Don't receive an email?{" "}
                                        <button
                                            type="button"
                                            className="text-primary-600 fw-semibold border-0 bg-transparent"
                                            onClick={() => setShowModal(false)}
                                        >
                                            Resend
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ForgotPassword;
